import isCharacteristicPrefix from '../helpers/isCharacteristicPrefix'
//-----------------------------------
// get skill formula characteristics
//----------------------------------
export default function getSkillFormulaCharacteristics(skill) {
  //
  let chars = []
  // where standard formula
  if (skill.formula && skill.formula != 'None') {
    if (isCharacteristicPrefix(skill.formula_arg1)) {
      chars.push(skill.formula_arg1)
    }
    if (isCharacteristicPrefix(skill.formula_arg2)) {
      chars.push(skill.formula_arg2)
    }
    if (isCharacteristicPrefix(skill.formula_arg3)) {
      chars.push(skill.formula_arg3)
    }
    // where parent
  } else {
    if (isCharacteristicPrefix(skill.parent_formula_arg1)) {
      chars.push(skill.parent_formula_arg1)
    }
    if (isCharacteristicPrefix(skill.parent_formula_arg2)) {
      chars.push(skill.parent_formula_arg2)
    }
    if (isCharacteristicPrefix(skill.parent_formula_arg3)) {
      chars.push(skill.parent_formula_arg3)
    }
  }
  return chars
}
